import type { CSSProperties, JSX, PropsWithChildren, ReactNode } from "react";

export interface CardProps extends PropsWithChildren {
  /**
   * Actions available in the card's `<footer>`. If not provided, the `<footer>`
   * will not be rendered at all.
   */
  actions?: ReactNode;

  /**
   * Title available in the card's `<header>`. If not provided, the `<header>`
   * will not be rendered at all.
   */
  title?: ReactNode;

  /** CSS style passed directly to the card's root `<div class="card">` */
  style?: CSSProperties;
}

/**
 * A simple _card_ component for displaying content in a general 3-part box:
 *
 * - `<header>`
 * - body
 * - `<footer>`
 */
export function Card(props: CardProps): JSX.Element | null {
  const { actions, children, title } = props;

  if (!actions && !children && !title) return null;

  return (
    <div className="card" style={props.style}>
      {title && <header>{title}</header>}
      {children && <div className="content">{children}</div>}
      {actions && <footer>{actions}</footer>}
    </div>
  );
}
